export const TEAMSPACE_RELEASE_DATE = '2025-04-14T00:00:00.000Z';
